'use strict';
angular.module('TurneroApp').component('coCalendarioExterno', {
	bindings: {
		ctrlPadre: '=',
		idTramiteRelevado: '<',
		idCentroAtencion: '<',
		modalidad: '<',
        agendaSeleccionada: '<'
	},
    controller: ['calendarioService', 'utilsService', 'centrosAtencionService', 'agendaService', 'portal', '$mdDialog', 'TurneroAppConstant', 'menuService', 'seguridadService', '$localStorage', '$rootScope', '$window', 'miDoctaModoService',
    function (calendarioService, utilsService, centrosAtencionService, agendaService, portal, $mdDialog, TurneroAppConstant, menuService, seguridadService, $localStorage, $rootScope, $window, miDoctaModoService) {
        var ctrl = this;
        ctrl.guardarTurno_data = null;
        ctrl.guardarTurno_anterior = null;
  	    ctrl.Modalidades = TurneroAppConstant.Modalidades;
  	    ctrl.semanaAnterirorPulsada = false;
        ctrl.mostrarPuestos = false;

  	    /* ctrl.semanaActual va a tener el lunes de la semana actual. en el caso HOY sea Domingo, le resto 6 dias para obtener el lunes de la semana de HOY
         en caso de que hoy sea un dia de la semana comun, le resto (el numero de dia  - 1 ) que me retorna el lunes de la semana.
         */
  	    ctrl.semanaActual = moment(moment(moment().add((moment().toDate().getDay() > 0 ? -(moment().toDate().getDay() - 1) : (-6)), 'days'))).toDate();
  	    ctrl.semana = {};

  	    ctrl.searchTerm = {
  		    text: ''
  	    };
  	    ctrl.clearSearchTerm = function () {
  		    ctrl.searchTerm = {
  			    text: ''
  		    };
  	    };
		  ctrl.limpiarDatosAPIExterna = function () {
			ctrl.Agenda.APILink = null;
			ctrl.Agenda.Respuesta = null;
		}
  	    ctrl.btnAnterior_ocultar = function () {
  		    if (ctrl.semana.Anterior) {
  			    if (ctrl.semanaActual && ctrl.semana.Anterior < moment(ctrl.semanaActual.toDateString()).toDate()) {
  				    return true;
  			    }
  			    if (ctrl.semana.primeraFecha && ctrl.semana.Anterior < moment(ctrl.semana.primeraFecha.toDateString()).toDate()) {
  				    return true;
  			    }

  			    return false;
  		    }
  		    return true;

  	    }

        ctrl.$onInit = function () {
            ctrl.obtenerPermisos();
        }

  	    ctrl.$onChanges = function (changes) {
  	        ctrl.ctrlPadre.ctrlHijo = ctrl;
  		    if (ctrl.idTramiteRelevado && ctrl.modalidad) {
  			    ctrl.cargarCentros(ctrl.idTramiteRelevado);
  			    if (ctrl.idCentroAtencion && ctrl.agendaSeleccionada) {
  				    ctrl.fechaSeleccionada = moment(moment().toDate()).locale('es');
  				    ctrl.cambiarDia(ctrl.fechaSeleccionada);
  			    }
  		    }
  	    };

  	    ctrl.obtenerAgendas = function (Id_Centro_Atencion, Id_Tramite) {
  		    ctrl.Id_Centro_Atencion = Id_Centro_Atencion;
			if (ctrl.modalidad == ctrl.Modalidades.Presencial) {
				ctrl.mostrarAgenda(Id_Centro_Atencion, Id_Tramite, ctrl);
				return;
			}

			  agendaService.Get_Info_API({'id_tramite_relevado': ctrl.Tramite.Id_Tramite}).$promise.then(function (datosApi) {
				ctrl.Agenda = datosApi;
				if(ctrl.Agenda.APILink != "" && ctrl.Agenda.Respuesta != "Iniciado")
				{
					if (ctrl.Agenda.Respuesta && ctrl.Agenda.Respuesta.includes("_ADV")) {
						swal({
							title: 'Atención',
							html: '¡Hemos detectado que Usted tiene un trámite de MI LICENCIA DIGITAL en curso!<br><br>Para retirar su licencia de conducir tramitada por la vía digital <a href="' + portal.getUrlServer() + 'turnos?tramitePortal=' + ctrl.Agenda.IdTramiteDigital + '">ingrese aquí</a>.<br><br>El trámite para el que está intentando sacar turno es \"' + ctrl.Tramite.N_Tramite + '\".<br><br>Por favor verifique que este trámite sea el que necesita.',
							type: 'warning',
							allowEscapeKey: false,
							allowOutsideClick: false,
							confirmButtonColor: 'rgb(48, 133, 214)',
							confirmButtonText: "Aceptar",
						}).then(function () {
							ctrl.mostrarAgenda(Id_Centro_Atencion, Id_Tramite, ctrl);
						})
					}
					else
					{
						swal({
							title: 'Atención',
							text: 'El tramite solicitado no esta disponible porque no tiene finalizada su gestión de licencia de conducir OnLine',
							type: 'warning',
							allowEscapeKey: false,
							allowOutsideClick: false,
							confirmButtonColor: 'rgb(48, 133, 214)',
							confirmButtonText: "Aceptar",
						}).then(function () {
							$window.location.href = miDoctaModoService.urlInternaConModo('/turnos');
						})
						ctrl.limpiarDatosAPIExterna();
					}
				}
				else
				{
					ctrl.mostrarAgenda(Id_Centro_Atencion, Id_Tramite, ctrl);
				}
			}).catch(function (error) {
				swal({
					title: 'Atención',
					text: 'Por un problema ajeno a esta plataforma, no hemos podido validar si posee un tramite de licencia online finalizado. Por favor vuelva a intentarlo mas tarde.',
					type: 'warning',
					allowEscapeKey: false,
					allowOutsideClick: false,
					confirmButtonColor: 'rgb(48, 133, 214)',
					confirmButtonText: "Aceptar",
				}).then(function () {
					$window.location.href = miDoctaModoService.urlInternaConModo('/turnos');
					})
			});
			
  	    }

		ctrl.mostrarAgenda = function (Id_Centro_Atencion, Id_Tramite, ctrl) {
			agendaService.Get_x_Centro_Modalidad({ 'id_centro_atencion': Id_Centro_Atencion, 'id_tramite_relevado': Id_Tramite, 'id_modalidad': ctrl.modalidad }).$promise.then(function (resultado) {
				ctrl.cantAgenda = resultado.Data.length;
				ctrl.Agenda = resultado.Data;
				  if (ctrl.cantAgenda == 1) {
					  ctrl.agendaSeleccionada = {
						  id: resultado.Data[0].id,
						  text: resultado.Data[0].text
					  };
					  ctrl.cambiarCalendario();
				  } else if (!ctrl.cantAgenda > 1) {
					  sweetAlert("Agendas no disponibles", "No hay agendas disponibles en el centro seleccionado.", "warning");
				  } else {  				    
					$mdDialog.show({
						template: require('./modalSeleccioneAgenda.html'),
						parent: angular.element(document.body),
						clickOutsideToClose: false,
						fullscreen: false,
						controllerAs: '$ctrl',
						controller: function () {
							return ctrl;
						}
					});
				}
			  })
		};

  	    ctrl.cerrarModal = function () {
  		    $mdDialog.destroy();
  	    };

  	    ctrl.cambiarAgenda = function () {
  		    if (ctrl.agendaSeleccionada != null && ctrl.agendaSeleccionada != undefined) {
                ctrl.cerrarModal();
                ctrl.cambiarDia(ctrl.fechaSeleccionada != new moment().toDate() && ctrl.fechaSeleccionada ? ctrl.fechaSeleccionada : new moment().toDate());
  		    } else {
  			    sweetAlert("Debe seleccionar una agenda de la opciones", '', "warning");
  		    }
  	    }
  	    ctrl.cargarCentros = function (Id_Tramite) {
  		    centrosAtencionService.Get_Centro_x_Tramite_Combo({ 'Id_Tramite_Relevado': Id_Tramite, 'Id_Modalidad': ctrl.modalidad }).$promise.then(function (result) {
  			    ctrl.centros_Atencion = result.Data;
  			    if (ctrl.centros_Atencion.length > 1) {
  				    for (var i = 0; i < ctrl.centros_Atencion.length; i++) {
  					    if (ctrl.centros_Atencion[i].id == ctrl.idCentroAtencion) {
  						    ctrl.ctrlPadre.centroSeleccionado = ctrl.centros_Atencion[i];
  						    ctrl.obtenerAgendas(ctrl.ctrlPadre.centroSeleccionado.id, ctrl.idTramiteRelevado)
  						    break;
  					    }
  				    }
  			    } else if (ctrl.centros_Atencion.length == 1) {
  				    ctrl.ctrlPadre.centroSeleccionado = ctrl.centros_Atencion[0];
  				    ctrl.obtenerAgendas(ctrl.ctrlPadre.centroSeleccionado.id, ctrl.idTramiteRelevado)
  			    }
  		    }).catch(function (error) {
  			    sweetAlert("Oops...", "Ocurrió un error en la operación.</br> " + error.data.ExceptionMessage, "error");
  		    })

  	    }

        ctrl.guardarTurno = function (hora, horahasta, fecha) {

            let tieneFechaSeleccionada = ctrl.guardarTurno_anterior != null;
            let fechaSeleccionadaNuevamente = false;

            if (ctrl.guardarTurno_anterior && ctrl.guardarTurno_anterior.dia === fecha && ctrl.guardarTurno_anterior.hora === hora && ctrl.guardarTurno_anterior.horaHasta === horahasta) {
                ctrl.guardarTurno_data = null;
                fechaSeleccionadaNuevamente = true;
            }
            else {
                ctrl.guardarTurno_data = {
                    dia: fecha,
                    hora: hora,
                    horaHasta: horahasta
                };
            }

            angular.forEach(ctrl.CalendarioArmado, function (value, key) {

                if (tieneFechaSeleccionada) {

                    if (value.lunes != null && value.lunes.Fecha == moment(ctrl.guardarTurno_anterior.dia).format('DD/MM/YYYY').toString() && value.lunes.Hora_Desde == ctrl.guardarTurno_anterior.hora && value.lunes.Hora_Hasta == ctrl.guardarTurno_anterior.horaHasta) {
                        value.lunes.esSeleccionado = false;
                    }

                    if (value.martes != null && value.martes.Fecha == moment(ctrl.guardarTurno_anterior.dia).format('DD/MM/YYYY').toString() && value.martes.Hora_Desde == ctrl.guardarTurno_anterior.hora && value.martes.Hora_Hasta == ctrl.guardarTurno_anterior.horaHasta) {
                        value.martes.esSeleccionado = false
                    }

                    if (value.miercoles != null && value.miercoles.Fecha == moment(ctrl.guardarTurno_anterior.dia).format('DD/MM/YYYY').toString() && value.miercoles.Hora_Desde == ctrl.guardarTurno_anterior.hora && value.miercoles.Hora_Hasta == ctrl.guardarTurno_anterior.horaHasta) {
                        value.miercoles.esSeleccionado = false;
                    }

                    if (value.jueves != null && value.jueves.Fecha == moment(ctrl.guardarTurno_anterior.dia).format('DD/MM/YYYY').toString() && value.jueves.Hora_Desde == ctrl.guardarTurno_anterior.hora && value.jueves.Hora_Hasta == ctrl.guardarTurno_anterior.horaHasta) {
                        value.jueves.esSeleccionado = false;
                    }

                    if (value.viernes != null && value.viernes.Fecha == moment(ctrl.guardarTurno_anterior.dia).format('DD/MM/YYYY').toString() && value.viernes.Hora_Desde == ctrl.guardarTurno_anterior.hora && value.viernes.Hora_Hasta == ctrl.guardarTurno_anterior.horaHasta) {
                        value.viernes.esSeleccionado = false;
                    }

                    if (value.sabado != null && value.sabado.Fecha == moment(ctrl.guardarTurno_anterior.dia).format('DD/MM/YYYY').toString() && value.sabado.Hora_Desde == ctrl.guardarTurno_anterior.hora && value.sabado.Hora_Hasta == ctrl.guardarTurno_anterior.horaHasta) {
                        value.sabado.esSeleccionado = false;
                    }

                    if (value.domingo != null && value.domingo.Fecha == moment(ctrl.guardarTurno_anterior.dia).format('DD/MM/YYYY').toString() && value.domingo.Hora_Desde == ctrl.guardarTurno_anterior.hora && value.domingo.Hora_Hasta == ctrl.guardarTurno_anterior.horaHasta) {
                        value.domingo.esSeleccionado = false;
                    }
                }

                if (fechaSeleccionadaNuevamente == false && value.lunes != null && value.lunes.Fecha == moment(fecha).format('DD/MM/YYYY').toString() && value.lunes.Hora_Desde == hora && value.lunes.Hora_Hasta == horahasta) {
                    value.lunes.esSeleccionado = true;
                }

                if (fechaSeleccionadaNuevamente == false && value.martes != null && value.martes.Fecha == moment(fecha).format('DD/MM/YYYY').toString() && value.martes.Hora_Desde == hora && value.martes.Hora_Hasta == horahasta) {
                    value.martes.esSeleccionado = true;
                }

                if (fechaSeleccionadaNuevamente == false && value.miercoles != null && value.miercoles.Fecha == moment(fecha).format('DD/MM/YYYY').toString() && value.miercoles.Hora_Desde == hora && value.miercoles.Hora_Hasta == horahasta) {
                    value.miercoles.esSeleccionado = true;
                }

                if (fechaSeleccionadaNuevamente == false && value.jueves != null && value.jueves.Fecha == moment(fecha).format('DD/MM/YYYY').toString() && value.jueves.Hora_Desde == hora && value.jueves.Hora_Hasta == horahasta) {
                    value.jueves.esSeleccionado = true;
                }

                if (fechaSeleccionadaNuevamente == false && value.viernes != null && value.viernes.Fecha == moment(fecha).format('DD/MM/YYYY').toString() && value.viernes.Hora_Desde == hora && value.viernes.Hora_Hasta == horahasta) {
                    value.viernes.esSeleccionado = true;
                }

                if (fechaSeleccionadaNuevamente == false && value.sabado != null && value.sabado.Fecha == moment(fecha).format('DD/MM/YYYY').toString() && value.sabado.Hora_Desde == hora && value.sabado.Hora_Hasta == horahasta) {
                    value.sabado.esSeleccionado = true;
                }

                if (fechaSeleccionadaNuevamente == false && value.domingo != null && value.domingo.Fecha == moment(fecha).format('DD/MM/YYYY').toString() && value.domingo.Hora_Desde == hora && value.domingo.Hora_Hasta == horahasta) {
                    value.domingo.esSeleccionado = true;
                }
            });

            if (!fechaSeleccionadaNuevamente) {
                ctrl.guardarTurno_anterior = Object.assign({}, ctrl.guardarTurno_data);
            }
  	    }

  	    ctrl.cambiarDia = function (fecha) {
  		    fecha = moment(fecha, "DD-MM-YYYY")._d;
  		    if (fecha.getDay() == 0) {
  			    fecha = moment(moment(fecha).add(-7, 'days')).toDate();
  			    //fecha.setDate(fecha.getDate() - 7)
  		    };

  		    //Obtengo la fecha del domingo del date picker

  		    fecha = moment(moment(fecha).add(-(fecha.getDay()), 'days')).toDate();
  		    //Obtengo la fecha del Lunes de la semana
  		    var fechaLunes = new Date();
  		    fechaLunes = moment(moment(fecha).add(1, 'days')).toDate();

            ctrl.guardarTurno_data = null;
  		    ctrl.obtenerDiasxSemana(fechaLunes);
  	    }
  	    ctrl.botonAnterior = function (fechaLunes, cargarNuevamente) {
  	        ctrl.semanaAnterirorPulsada = true;
  	        ctrl.obtenerDiasxSemana(fechaLunes, cargarNuevamente);
  	    };

  	    ctrl.obtenerDiasxSemana = function (fechaLunes) {
  		    ctrl.semana.Dias = [];
                ctrl.semana.Siguiente = moment(moment(fechaLunes).add(7, 'days')).format('DD/MM/YYYY').toDate();

                ctrl.semana.Anterior = moment(moment(fechaLunes).add(-7, 'days')).format('DD/MM/YYYY').toDate();

  		    for (var i = 0; i < 7; i++) {
                    var fecha = moment(moment(fechaLunes).add(i, 'days')).format('DD/MM/YYYY').toDate();
  			    ctrl.semana.Dias[i] = fecha;
  		    }
  		    if (ctrl.agendaSeleccionada) {
  			    ctrl.getCalendario(ctrl.agendaSeleccionada.id, ctrl.semana.Dias[0]);
            }
        }

  	    ctrl.mostrarFecha = function (fecha_calendario, fecha) {
  		    var momentDate = moment(fecha_calendario, 'DD/MM/YYYY')._d;
  		    if (momentDate.getDate() == fecha.getDate() && momentDate.getMonth() == fecha.getMonth() && momentDate.getYear() == fecha.getYear()) {
  			    return true;
  		    }
  		    return false;
  	    };

  	    ctrl.ParseValues = function (value) {
  		    if (value) {
  			    if (value.Id_Bloqueo_Calendario != 0) {
  				    return 'B'; //Bloqueado
  			    } else if (parseInt(value.Libre) > 0) {
  				    return 'L';//Disponible
  			    } else {
  				    return 'O';//Ocupado
  			    }
  		    } else return false;

  	    }

  	    ctrl.validarFechaEnSemana = function (fecha) {
  		    //Verifico si la fecha que devuelve el calendario se encuentra dentro de la semana cargada  : True, sino : False
  		    var resultado = false;
  		    for (var i = 0; i < ctrl.semana.Dias.length; i++) {
  			    if (ctrl.mostrarFecha(moment(fecha).toDate(), ctrl.semana.Dias[i])) {
  				    resultado = true;
  				    break;
  			    }
  		    }
  		    return resultado;

  	    }

  	    ctrl.getCalendario = function (Id_Agenda, fecha) {
  		    ctrl.CalendarioArmado = [];
            var ServicioCalendario = (ctrl.modalidad == ctrl.Modalidades.OnLine ? calendarioService.Get_Calendario_Online :
                    (ctrl.modalidad == ctrl.Modalidades.Presencial ? calendarioService.Get_Calendario : null));
            if (ctrl.modalidad == ctrl.Modalidades.Presencial) {
                ctrl.mostrarPuestos = true;
            }
  		    if (ServicioCalendario) {
  			    utilsService.swalNotification('Un momento...', 'Consultando disponibilidad...', 'info');
  			    ServicioCalendario({ 'id_agenda': Id_Agenda, 'fecha': fecha, 'Id_Tramite_Relevado': ctrl.idTramiteRelevado }, function (resultado) {
  				    try {
  					    ctrl.semana.ultimaFecha = moment(moment(resultado.Data.Fecha_Ultimo_Turno)).toDate();
  					    ctrl.semana.primeraFecha = moment(moment(resultado.Data.Fecha_Primer_Turno)).toDate();
  					    ctrl.semana.ultimaSemana = moment(moment(ctrl.semana.ultimaFecha)).toDate();
  					    ctrl.semana.Lunes_Semana_Calendario = moment(moment(resultado.Data.Fecha_Disponible)).toDate();
  					    if (ctrl.validarFechaEnSemana(resultado.Data.Fecha_Disponible)) {
  						    ctrl.Calendario = resultado.Data;
  						    if (ctrl.Calendario.Filas.length) {
  							    ctrl.armadoCalendario(ctrl.Calendario.Filas);
  						    }/* else {
                                ctrl.regresar();
                            }*/
  						    ctrl.semanaAnterirorPulsada = false;
                          } else {
                              if (ctrl.semanaAnterirorPulsada) {
                                  ctrl.cambiarDia(moment(moment(fecha).add(-7, 'days')).toDate(), true);
                              }
                              else {
                                  ctrl.cambiarDia(moment(resultado.Data.Fecha_Disponible), true);
                              }
                          }
  					    //swal.close();
  				    } catch (e) {
  					    utilsService.errores(e);
  				    }

  			    }, function (error) {
  				    //swal.close();
  				    utilsService.errores(error);
  			    })

  		    } else {
  			    swal({
  				    title: 'Modalidad de turno inexistente',
  				    html: "La modalidad del turno que está intentando obtener no existe, por favor verifíquelo y vuelva a intentarlo",
  				    type: 'warning',
  				    confirmButtonColor: '#004b81',
  				    confirmButtonText: 'Aceptar',
  			    })

  		    }
  	    }

  	    ctrl.armadoCalendario = function (Filas) {
  		    ctrl.CalendarioArmado = [];
  		    for (var i = 0; i < Filas.length; i++) {
  			    var arrayElement = {
  				    hora: null,
  				    lunes: null,
  				    martes: null,
  				    miercoles: null,
  				    jueves: null,
  				    viernes: null,
  				    sabado: null,
  				    domingo: null
  			    };
  			    arrayElement.hora = Filas[i].Hora_Desde;
  			    var arrayElement_Hora_Hasta = arrayElement;
  			    for (var j = 0; j < 7; j++) {
  				    if (Filas[i] && arrayElement.hora == Filas[i].Hora_Desde) {
  					    switch (j) {
  						    case 0:
  							    if (ctrl.mostrarFecha(Filas[i].Fecha, ctrl.semana.Dias[j])) {
                                    arrayElement.lunes = Filas[i];

                                    if (ctrl.guardarTurno_data != null)
                                        arrayElement.lunes.esSeleccionado = (moment(ctrl.guardarTurno_data.dia).format('DD/MM/YYYY').toString() == arrayElement.lunes.Fecha && arrayElement.lunes.Hora_Desde == ctrl.guardarTurno_data.hora && arrayElement.lunes.Hora_Hasta == ctrl.guardarTurno_data.horaHasta);
                                    else
                                        arrayElement.lunes.esSeleccionado = false;

  								    arrayElement.lunes.Cant_Puestos = Filas[i].Libre + Filas[i].Ocupado;
  								    arrayElement.lunes.Cant_Puestos_Array = ctrl.generarArray(arrayElement.lunes.Cant_Puestos, Filas[i].Ocupado);
  								    i++;
  							    }
  							    break;
  						    case 1:
  							    if (ctrl.mostrarFecha(Filas[i].Fecha, ctrl.semana.Dias[j])) {
                                    arrayElement.martes = Filas[i];

                                    if (ctrl.guardarTurno_data != null)
                                        arrayElement.martes.esSeleccionado = (moment(ctrl.guardarTurno_data.dia).format('DD/MM/YYYY').toString() == arrayElement.martes.Fecha && arrayElement.martes.Hora_Desde == ctrl.guardarTurno_data.hora && arrayElement.martes.Hora_Hasta == ctrl.guardarTurno_data.horaHasta);
                                    else
                                        arrayElement.martes.esSeleccionado = false;

  								    arrayElement.martes.Cant_Puestos = Filas[i].Libre + Filas[i].Ocupado;
  								    arrayElement.martes.Cant_Puestos_Array = ctrl.generarArray(arrayElement.martes.Cant_Puestos, Filas[i].Ocupado);
  								    i++;
  							    }
  							    break;
  						    case 2:
  							    if (ctrl.mostrarFecha(Filas[i].Fecha, ctrl.semana.Dias[j])) {
                                    arrayElement.miercoles = Filas[i];

                                    if (ctrl.guardarTurno_data != null)
                                        arrayElement.miercoles.esSeleccionado = (moment(ctrl.guardarTurno_data.dia).format('DD/MM/YYYY').toString() == arrayElement.miercoles.Fecha && arrayElement.miercoles.Hora_Desde == ctrl.guardarTurno_data.hora && arrayElement.miercoles.Hora_Hasta == ctrl.guardarTurno_data.horaHasta);
                                    else
                                        arrayElement.miercoles.esSeleccionado = false;

  								    arrayElement.miercoles.Cant_Puestos = Filas[i].Libre + Filas[i].Ocupado;
  								    arrayElement.miercoles.Cant_Puestos_Array = ctrl.generarArray(arrayElement.miercoles.Cant_Puestos, Filas[i].Ocupado);
  								    i++;
  							    }
  							    break;
  						    case 3:
  							    if (ctrl.mostrarFecha(Filas[i].Fecha, ctrl.semana.Dias[j])) {
                                    arrayElement.jueves = Filas[i];

                                    if (ctrl.guardarTurno_data != null)
                                        arrayElement.jueves.esSeleccionado = (moment(ctrl.guardarTurno_data.dia).format('DD/MM/YYYY').toString() == arrayElement.jueves.Fecha && arrayElement.jueves.Hora_Desde == ctrl.guardarTurno_data.hora && arrayElement.jueves.Hora_Hasta == ctrl.guardarTurno_data.horaHasta);
                                    else
                                        arrayElement.jueves.esSeleccionado = false;

  								    arrayElement.jueves.Cant_Puestos = Filas[i].Libre + Filas[i].Ocupado;
  								    arrayElement.jueves.Cant_Puestos_Array = ctrl.generarArray(arrayElement.jueves.Cant_Puestos, Filas[i].Ocupado);
  								    i++;
  							    }
  							    break;
  						    case 4:
  							    if (ctrl.mostrarFecha(Filas[i].Fecha, ctrl.semana.Dias[j])) {
                                    arrayElement.viernes = Filas[i];

                                    if (ctrl.guardarTurno_data != null)
                                        arrayElement.viernes.esSeleccionado = (moment(ctrl.guardarTurno_data.dia).format('DD/MM/YYYY').toString() == arrayElement.viernes.Fecha && arrayElement.viernes.Hora_Desde == ctrl.guardarTurno_data.hora && arrayElement.viernes.Hora_Hasta == ctrl.guardarTurno_data.horaHasta);
                                    else
                                        arrayElement.viernes.esSeleccionado = false;

  								    arrayElement.viernes.Cant_Puestos = Filas[i].Libre + Filas[i].Ocupado;
  								    arrayElement.viernes.Cant_Puestos_Array = ctrl.generarArray(arrayElement.viernes.Cant_Puestos, Filas[i].Ocupado);
  								    i++;
  							    }
  							    break;
  						    case 5:
  							    if (ctrl.mostrarFecha(Filas[i].Fecha, ctrl.semana.Dias[j])) {
                                    arrayElement.sabado = Filas[i];

                                    if (ctrl.guardarTurno_data != null)
                                        arrayElement.sabado.esSeleccionado = (moment(ctrl.guardarTurno_data.dia).format('DD/MM/YYYY').toString() == arrayElement.sabado.Fecha && arrayElement.sabado.Hora_Desde == ctrl.guardarTurno_data.hora && arrayElement.sabado.Hora_Hasta == ctrl.guardarTurno_data.horaHasta);
                                    else
                                        arrayElement.sabado.esSeleccionado = false;

  								    arrayElement.sabado.Cant_Puestos = Filas[i].Libre + Filas[i].Ocupado;
  								    arrayElement.sabado.Cant_Puestos_Array = ctrl.generarArray(arrayElement.sabado.Cant_Puestos, Filas[i].Ocupado);
  								    i++;
  							    }
  							    break;
  						    case 6:
  							    if (ctrl.mostrarFecha(Filas[i].Fecha, ctrl.semana.Dias[j])) {
                                    arrayElement.domingo = Filas[i];

                                    if (ctrl.guardarTurno_data != null)
                                        arrayElement.domingo.esSeleccionado = (moment(ctrl.guardarTurno_data.dia).format('DD/MM/YYYY').toString() == arrayElement.domingo.Fecha && arrayElement.domingo.Hora_Desde == ctrl.guardarTurno_data.hora && arrayElement.domingo.Hora_Hasta == ctrl.guardarTurno_data.horaHasta);
                                    else
                                        arrayElement.domingo.esSeleccionado = false;

  								    arrayElement.domingo.Cant_Puestos = Filas[i].Libre + Filas[i].Ocupado;
  								    arrayElement.domingo.Cant_Puestos_Array = ctrl.generarArray(arrayElement.domingo.Cant_Puestos, Filas[i].Ocupado);
  								    i++;
  							    }
  							    break;
  					    }

  				    }
  			    }
  			    ctrl.CalendarioArmado.push(arrayElement);
  			    i = i - 1;
  		    }
		    swal.close();
  	    }

  	    ctrl.generarArray = function (cantidad, cantOcupados) {
  	        var arrayResult = [];
  	        for (var i = 1; i <= cantidad; i++) {
  	            var item = {
  	                id: i,
  	                ocupado: i <= cantOcupados
  	            }
  	            arrayResult.push(item);
  	        }
  	        return arrayResult;

  	    }

  	    ctrl.cambiarCalendario = function () {
  		    if (ctrl.agendaSeleccionada) {
  			    ctrl.fechaSeleccionada = ctrl.fechaSeleccionada ? ctrl.fechaSeleccionada : moment(moment().toDate()).locale('es');
  			    ctrl.cambiarDia(ctrl.fechaSeleccionada);
  		    }
          }

        ctrl.siguiente = function () {
            if (ctrl.guardarTurno_data != null) {
                ctrl.ctrlPadre.confirmarTurno(ctrl.guardarTurno_data);
            }
        }

        ctrl.obtenerPermisos = function () {
            if (ctrl.idCentroAtencion && ctrl.modalidad !== ctrl.Modalidades.OnLine)
            {
                menuService.get({ 'id_centro_atencion': ctrl.idCentroAtencion }).$promise.then(function (data) {
                    if (data.Permisos) {
                        seguridadService.permisos = data.Permisos;
                        $localStorage.TurneroApp_Authorization.usuario.permisos = data.Permisos;
                    }
                    $rootScope.$$phase != '$digest' ? $rootScope.$digest() : '';
                }).catch(function (error) {
                    utilsService.errores(error);
                });
            }            
        }
  }],
	template: require('./calendarioExterno.html')
});



// WEBPACK FOOTER //
// ./app/shared/calendarioExterno/calendarioExternoComponent.js